module.exports = __webpack_public_path__ + "img/Unknowns_Icon_Up.cd4a8bc8.svg";